import React, { useEffect, useState } from 'react';
import EventNoteIcon from '@mui/icons-material/EventNote';
import MapIcon from '@mui/icons-material/Map';
import ForestIcon from '@mui/icons-material/Forest';
import SettingsIcon from '@mui/icons-material/Settings';
import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Dialog,
  Typography,
  Grid,
  TextField,
  InputLabel,
  Autocomplete,
  Box,
  createFilterOptions,
  Tooltip,
  Radio,
  Chip,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { purchseTypeRadioFields, typeOfPurchaseReqFormOption } from '../Data/PurchseReqDropDownData';
import SectionAccordians from 'routes/Pages/components/Accordians/SectionAccordians';
import InputsRendered, { DropzoneUpload } from './InputsRendered';
import {
  ACCOMODATION_INFO_DEFAULT_DATA,
  DEFAULT_DIESEL_LOCATION_DATA,
  DEFAULT_RECHARGE_DATA,
  DEFAUTL_DIESEL_DATA,
  GENERAL_SECTION_DEFAULT_DATA,
  PURCHASE_INFO_DEFAUTL_DATA,
  TYPE_OF_PURCHASE_REQ_FORM,
} from '../Data/DefaultPurchaseReqData';
import {
  AccommodationIpFields,
  DieselLocationIpFields,
  DieselLocationIpFields2,
  DieselQtyIpFields,
  GeneralSectionIpFields,
  originamReqIpField,
  purchaseOption,
  RechargeIPFields,
  warrantyOption,
} from '../Data/PurchaseReqFormIPFields';
import customAxios from 'routes/Pages/util/Api';
import { FETCH_ERROR, FETCH_START, FETCH_SUCCESS } from 'routes/Pages/constants/ActionTypes';
import { useDispatch } from 'react-redux';
import authHeader from 'services/auth/jwt/auth-header';
import { useAllUsers } from 'context/AllUserDataContext';
import usePurchseReqFormHook from '../CustomHooks/usePurchseReqFormHook';

const filter = createFilterOptions();
const AddPurchaseRequisitionForm = ({
  open,
  setOpen,
  handlePurchseReqSubmit,
  isEdit,
  selectedPurchaseReq,
  handleRfqEdit,
  handleOpenConfirmationDialog,
}) => {
  const {
    getSelectedAllUserVal,
    handlespDataChange,
    handleDieselLocationDataChange,
    handleDieselDataChange,
    handleRechargeDataChange,
    handleAccomodationDataChange,
    handleFileChange,
    handlePurchaseTypeChange,
    handlePuchseSectionDataChange,
    handleGeneralSectionEdit,
    handleFormSubmit,
    handleClose,
    getSPList,
    allUsers,
    spListObj,
    setSPListObj,
    spList,
    setSPList,
    dieselLocationInfo,
    setDieselLocationInfo,
    dieselPurchanseInfo,
    setDieselPurchanseInfo,
    rechargeData,
    setRechargeData,
    accomodationData,
    setAccomodationData,
    purchseReqDocs,
    setPurchseReqDocs,
    purchaseSectionData,
    setPurchaseSectionData,
    generalSectionData,
    setGeneralSectionData,
    typeOfPurchaseReqForm,
    setTypeOfPurchaseReqForm,
    uploadedDocsForReq,
    handleFileDelete,
    viewFile,
  } = usePurchseReqFormHook(open, setOpen, handlePurchseReqSubmit, isEdit, selectedPurchaseReq, handleRfqEdit);
  const handleDeleteFiles = fileData => {
    // handleFileDelete;
    handleOpenConfirmationDialog(
      'This will delete the selected file. Are you sure? ',
      () => handleFileDelete(fileData),
      null,
    );
  };
  return (
    <Dialog
      sx={{
        fontFamily: 'Normal !important',
      }}
      fullWidth
      maxWidth="lg"
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}>
      <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
        {isEdit ? 'Edit Purchase Purchase Requisition' : 'Purchase Requisition Form'}
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={theme => ({
          position: 'absolute',
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}>
        <CloseIcon />
      </IconButton>
      <form
        onSubmit={handleFormSubmit}
        onKeyDown={e => {
          if (e.key === 'Enter' && e.target.tagName !== 'TEXTAREA') {
            e.preventDefault();
          }
        }}>
        <DialogContent
          dividers
          sx={{
            overflow: 'auto',
          }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            <Box
              sx={{
                backgroundColor: 'rgb(236 236 236)',
                borderRadius: '0.5rem',
                padding: '0px 16px',
                display: 'flex',
                alignItems: 'center',
                flexWrap: 'wrap',
                gap: '12px',
                fontSize: '14px',
                justifyContent: 'space-between',
                flexDirection: 'row-reverse',
              }}>
              <div style={{ display: 'flex', justifyContent: 'start', alignItems: 'center' }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 500, mr: 2, lineHeight: 1 }}>
                  Links:
                </Typography>

                <Tooltip title="Link To Fuel Requisition">
                  <IconButton
                    href="https://docs.google.com/spreadsheets/d/e/2PACX-1vQM5gTwxr2bIVt7wg8xNQC64Bt2uHw4h4iRNpJpQam6o6aPG5Rik654Has7OryuwRtm6RhkX8IG3ln_/pubhtml"
                    target="_blank"
                    rel="noopener"
                    size="small">
                    <MapIcon color="primary" />
                  </IconButton>
                </Tooltip>

                <Tooltip title="Training Video">
                  <IconButton
                    href="https://worrellharvestingltd.sharepoint.com/sites/Operations/_layouts/15/stream.aspx"
                    size="small"
                    target="_blank">
                    <EventNoteIcon color="primary" />
                  </IconButton>
                </Tooltip>
              </div>
              <div>
                <InputLabel
                  size="small"
                  sx={{
                    paddingBottom: '10px',
                    fontSize: '0.8rem',
                    color: 'black',
                  }}>
                  Type of Purchase Requisition Form
                </InputLabel>
                <Autocomplete
                  size="small"
                  value={typeOfPurchaseReqForm}
                  options={typeOfPurchaseReqFormOption}
                  onChange={(event, newValue) => setTypeOfPurchaseReqForm(newValue)}
                  sx={{ fontSize: '0.8rem' }}
                  renderInput={params => (
                    <TextField helperText="Select Type Of Purchase Requisition Form" {...params} size="small" fullWidth />
                  )}
                  fullWidth
                  disabled={isEdit}
                />
              </div>
            </Box>
            {typeOfPurchaseReqForm == 'Return' && (
              <Box
                sx={{
                  backgroundColor: 'rgb(236 236 236)',
                  borderRadius: '0.5rem',
                  padding: '8px 16px',
                  display: 'flex',
                  alignItems: 'center',
                  flexWrap: 'wrap',
                  gap: '12px',
                  fontSize: '14px',
                  justifyContent: 'space-between',
                  flexDirection: 'row-reverse',
                }}>
                <Typography variant="body1">
                  For Returns please enter as much detail as necessary and attach the orginal documents that were used to
                  order the product. Please also enter the original PR number and upload a copy of the original order and
                  return documents so as to facilitate processing by Admin. The more information provided the better. Thank
                  you.
                </Typography>
              </Box>
            )}
            {typeOfPurchaseReqForm == 'Recharge' && (
              <Box>
                <Typography variant="h6">Recharge Data</Typography>
                <InputsRendered
                  handleIpChangeChange={handleRechargeDataChange}
                  inputFieldsData={rechargeData}
                  inputFieldsArr={RechargeIPFields}
                />
              </Box>
            )}
            {typeOfPurchaseReqForm != 'Diesel Purchase' && (
              <Box>
                <Typography variant="h6">General Information</Typography>
                <InputsRendered
                  handleIpChangeChange={handleGeneralSectionEdit}
                  inputFieldsArr={
                    typeOfPurchaseReqForm == 'Return'
                      ? [originamReqIpField, ...GeneralSectionIpFields]
                      : GeneralSectionIpFields
                  }
                  inputFieldsData={generalSectionData}
                />
              </Box>
            )}
            {(typeOfPurchaseReqForm == 'Purchase' || typeOfPurchaseReqForm == 'Return') && (
              <Box>
                <Typography variant="h6">Purchase Section Data</Typography>
                <InputsRendered
                  handleIpChangeChange={handlePuchseSectionDataChange}
                  inputFieldsArr={purchaseOption}
                  inputFieldsData={purchaseSectionData}
                />
                <InputLabel
                  size="small"
                  sx={{
                    paddingBottom: '10px',
                    fontSize: '0.825rem',
                    color: 'black',
                    width: '100%',
                    paddingLeft: '0.5rem',
                  }}>
                  Type
                </InputLabel>
                <Grid
                  container
                  spacing={1}
                  sx={{
                    '& .MuiTableCell-root': {
                      fontSize: '0.825rem',
                    },
                    '& .MuiInputBase-root': {
                      fontSize: '0.825rem !important',
                    },
                    paddingInline: '0.5rem',
                    paddingTop: '0.5rem',
                  }}>
                  {purchseTypeRadioFields.map(radioFiedls => {
                    return (
                      <Grid item md={2} key={radioFiedls}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <Radio
                            checked={purchaseSectionData['type'] === radioFiedls}
                            onChange={handlePurchaseTypeChange}
                            value={radioFiedls}
                            name="type"
                            slotprops={{ input: { 'aria-label': 'Yes' } }}
                          />
                          <InputLabel
                            style={{
                              marginBottom: 0,
                              fontSize: '0.725rem',
                              whiteSpace: 'normal', // allows text to wrap
                              overflowWrap: 'break-word',
                            }}>
                            {radioFiedls}
                          </InputLabel>
                        </div>
                      </Grid>
                    );
                  })}
                </Grid>
                <Grid
                  container
                  spacing={1}
                  sx={{
                    '& .MuiTableCell-root': {
                      fontSize: '0.825rem',
                    },
                    '& .MuiInputBase-root': {
                      fontSize: '0.825rem !important',
                    },
                  }}>
                  {(purchaseSectionData.type == 'Tools' ||
                    purchaseSectionData.type == 'Spare Tyre' ||
                    purchaseSectionData.type == 'Tracks') && (
                    <Grid item xs={6} sm={6} md={6}>
                      <InputLabel
                        size="small"
                        sx={{
                          paddingBottom: '10px',
                          fontSize: '0.825rem',
                          color: 'black',
                        }}
                        required={true}>
                        Tools Assigned To
                      </InputLabel>

                      <Autocomplete
                        size="small"
                        name="toolsAssignedTo"
                        required={true}
                        options={allUsers}
                        value={getSelectedAllUserVal(purchaseSectionData.toolsAssignedTo)}
                        getOptionLabel={option => option.email}
                        onChange={(e, newValue) =>
                          handlePuchseSectionDataChange('toolsAssignedTo', newValue ? newValue.email : '')
                        }
                        isOptionEqualToValue={(option, value) => option?.email === value?.email}
                        sx={{ fontSize: '0.8rem' }}
                        renderInput={params => (
                          <TextField helperText={'Person who is given the tool'} {...params} size="small" fullWidth />
                        )}
                        fullWidth
                      />
                    </Grid>
                  )}
                  {purchaseSectionData.type == 'Other' && (
                    <Grid item xs={6} sm={6} md={6}>
                      <InputLabel
                        size="small"
                        sx={{
                          paddingBottom: '10px',
                          fontSize: '0.825rem',
                          color: 'black',
                        }}
                        required={true}>
                        Enter Other Option
                      </InputLabel>

                      <TextField
                        size="small"
                        variant="outlined"
                        type={'text'}
                        fullWidth
                        value={purchaseSectionData['otherOption']}
                        onChange={e => handlePuchseSectionDataChange(e.target.name, e.target.value)}
                        name="otherOption"
                        required={true}
                      />
                    </Grid>
                  )}
                </Grid>
              </Box>
            )}
            {typeOfPurchaseReqForm == 'Accommodation' && (
              <Box>
                <Typography variant="h6">Accommodation Data</Typography>
                <InputsRendered
                  handleIpChangeChange={handleAccomodationDataChange}
                  inputFieldsData={accomodationData}
                  inputFieldsArr={AccommodationIpFields}
                />
              </Box>
            )}
            {typeOfPurchaseReqForm != 'Diesel Purchase' && (
              <Box>
                <Typography variant="h6" sx={{ paddingTop: '1rem' }}>
                  Warranty Details
                </Typography>
                <InputsRendered
                  handleIpChangeChange={handlePuchseSectionDataChange}
                  inputFieldsArr={warrantyOption}
                  inputFieldsData={purchaseSectionData}
                />
                <Typography variant="h6" sx={{ paddingTop: '1rem' }}>
                  File and Invoice Upload
                </Typography>
                <Box
                  sx={{
                    flexGrow: 1,
                    paddingTop: '1rem',
                    '& .MuiTypography-root': {
                      fontSize: '0.825rem !important',
                    },
                  }}>
                  <Grid container spacing={4}>
                    {/* Upload for Office */}
                    <Grid item xs={12} md={6}>
                      <DropzoneUpload label="File Upload" onFileSelect={handleFileChange('file')} multiple={true} />
                      <Box
                        sx={{
                          display: 'flex',
                          overflowX: 'auto',
                          gap: 1,
                          py: 1,
                          px: 0.5,
                        }}>
                        {uploadedDocsForReq.file &&
                          uploadedDocsForReq.file.length > 0 &&
                          uploadedDocsForReq.file.map((file, index) => (
                            <Tooltip title={file.documentName} key={index}>
                              <Chip
                                label={
                                  file.documentName.length > 20 ? file.documentName.slice(0, 18) + '…' : file.documentName
                                }
                                color="success" // red primary color
                                sx={{
                                  fontSize: '0.7rem', // Slightly bigger text
                                  height: '24px',
                                  px: 1,
                                }}
                                onDelete={() => {
                                  handleDeleteFiles(file);
                                }}
                                onClick={() => viewFile(file)}
                              />
                            </Tooltip>
                          ))}
                      </Box>
                    </Grid>

                    {/* Upload for Operator */}
                    <Grid item xs={12} md={6}>
                      <DropzoneUpload label="Invoice Upload" onFileSelect={handleFileChange('invoice')} multiple={true} />
                      <Box
                        sx={{
                          display: 'flex',
                          overflowX: 'auto',
                          gap: 1,
                          py: 1,
                          px: 0.5,
                        }}>
                        {uploadedDocsForReq.invoice &&
                          uploadedDocsForReq.invoice.length > 0 &&
                          uploadedDocsForReq.invoice.map((file, index) => (
                            <Tooltip title={file.documentName} key={index}>
                              <div>
                                <Chip
                                  label={
                                    file.documentName.length > 20 ? file.documentName.slice(0, 18) + '…' : file.documentName
                                  }
                                  color="success" // red primary color
                                  sx={{
                                    fontSize: '0.7rem', // Slightly bigger text
                                    height: '24px',
                                    px: 1,
                                  }}
                                  onDelete={() => {
                                    handleDeleteFiles(file);
                                  }}
                                  onClick={() => viewFile(file)}
                                />
                              </div>
                            </Tooltip>
                          ))}
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              </Box>
            )}
            {console.log('allUsers sample:', allUsers[0])}
            {console.log('spList sample:', spList[0])}
            {console.log('spListObj keys sample:', Object.keys(spListObj)[0])}
            {typeOfPurchaseReqForm == 'Diesel Purchase' && (
              <Box>
                <InputsRendered
                  inputFieldsData={dieselLocationInfo}
                  inputFieldsArr={DieselLocationIpFields}
                  handleIpChangeChange={handleDieselLocationDataChange}
                />
                {isEdit && dieselLocationInfo.requisitionStatus === 'Ordered' && (
                  <Grid container spacing={1} sx={{ '& .MuiInputBase-root': { fontSize: '0.825rem !important' } }}>
                    <Grid item xs={6} sm={6} md={4}>
                      <InputLabel size="small" sx={{ paddingBottom: '10px', fontSize: '0.825rem', color: 'black' }} required>
                        Supplier Name
                      </InputLabel>
                      <TextField
                        size="small"
                        variant="outlined"
                        type="text"
                        fullWidth
                        value={dieselLocationInfo.supplierName || ''}
                        onChange={e => handleDieselLocationDataChange('supplierName', e.target.value)}
                        name="supplierName"
                        required
                        helperText="Required when status is Ordered"
                      />
                    </Grid>
                  </Grid>
                )}
                <Grid item xs={6} sm={6} md={6}>
                  <InputLabel
                    size="small"
                    sx={{
                      paddingBottom: '10px',
                      fontSize: '0.825rem',
                      color: 'black',
                    }}>
                    Originated dBy
                  </InputLabel>

                  <Autocomplete
                    size="small"
                    disablePortal
                    name="originatedBy"
                    value={
                      allUsers.find(u => u.email === dieselLocationInfo.originatedBy) ||
                      allUsers.find(u => u.displayName === dieselLocationInfo.originatedBy) ||
                      null
                    }
                    options={allUsers}
                    getOptionLabel={option => option.displayName} // show displayName not email
                    isOptionEqualToValue={(option, value) => option?.email === value?.email}
                    onChange={(event, newValue) =>
                      handleDieselLocationDataChange('originatedBy', newValue ? newValue.displayName : '')
                    }
                    renderInput={params => (
                      <TextField helperText="Person raising the Requisition" {...params} size="small" fullWidth />
                    )}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={6} sm={6} md={6}>
                  <InputLabel
                    size="small"
                    sx={{
                      paddingBottom: '10px',
                      fontSize: '0.825rem',
                      color: 'black',
                    }}>
                    SP List
                  </InputLabel>

                  <Autocomplete
                    size="small"
                    disablePortal
                    name="sp"
                    value={dieselLocationInfo.whInfoObj || null}
                    options={spList}
                    getOptionLabel={option => `${option.contractUniqueID} - ${option.wH_NumberName}`}
                    isOptionEqualToValue={(option, value) => option?.contractUniqueID === value?.contractUniqueID}
                    onChange={(event, newValue) => handlespDataChange('sp', newValue)}
                    renderInput={params => (
                      <TextField
                        helperText="Start typing and select SP to fill drop pins"
                        {...params}
                        size="small"
                        fullWidth
                      />
                    )}
                    fullWidth
                  />
                </Grid>
                <InputsRendered
                  inputFieldsData={dieselLocationInfo}
                  inputFieldsArr={DieselLocationIpFields2}
                  handleIpChangeChange={handleDieselLocationDataChange}
                />

                <Typography variant="h6" sx={{ paddingTop: '1rem' }}>
                  Diesel Order Info
                </Typography>
                <InputsRendered
                  inputFieldsArr={DieselQtyIpFields}
                  handleIpChangeChange={handleDieselDataChange}
                  inputFieldsData={dieselPurchanseInfo}
                />

                {dieselLocationInfo.requisitionStatus === 'Approved' && (
                  <Box>
                    <Typography variant="h6" sx={{ paddingTop: '1rem' }}>
                      File and Invoice Upload{' '}
                      <Typography component="span" color="error">
                        *
                      </Typography>
                    </Typography>
                    <Grid container spacing={4} sx={{ paddingTop: '1rem' }}>
                      <Grid item xs={12} md={6}>
                        <DropzoneUpload
                          label="File Upload"
                          onFileSelect={handleFileChange('file')}
                          multiple={true}
                          required={true}
                        />
                        <Box sx={{ display: 'flex', overflowX: 'auto', gap: 1, py: 1, px: 0.5 }}>
                          {uploadedDocsForReq.file?.map((file, index) => (
                            <Tooltip title={file.documentName} key={index}>
                              <Chip
                                label={
                                  file.documentName.length > 20 ? file.documentName.slice(0, 18) + '…' : file.documentName
                                }
                                color="success"
                                sx={{ fontSize: '0.7rem', height: '24px', px: 1 }}
                                onDelete={() => handleDeleteFiles(file)}
                                onClick={() => viewFile(file)}
                              />
                            </Tooltip>
                          ))}
                        </Box>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <DropzoneUpload
                          label="Invoice Upload"
                          onFileSelect={handleFileChange('invoice')}
                          multiple={true}
                          required={true}
                        />
                        <Box sx={{ display: 'flex', overflowX: 'auto', gap: 1, py: 1, px: 0.5 }}>
                          {uploadedDocsForReq.invoice?.map((file, index) => (
                            <Tooltip title={file.documentName} key={index}>
                              <Chip
                                label={
                                  file.documentName.length > 20 ? file.documentName.slice(0, 18) + '…' : file.documentName
                                }
                                color="success"
                                sx={{ fontSize: '0.7rem', height: '24px', px: 1 }}
                                onDelete={() => handleDeleteFiles(file)}
                                onClick={() => viewFile(file)}
                              />
                            </Tooltip>
                          ))}
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                )}
              </Box>
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="primary" type="submit">
            {isEdit ? 'Save Edit' : 'Save'}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default AddPurchaseRequisitionForm;
